import { cloneDeep } from 'lodash'

import { labelModes, permissionPresets, proxy, services } from '@/utils'

import render from './render'

export default {
  name: 'SelectorOwner',

  mixins: [ proxy() ],

  props: {
    permission: {
      type: String,
      default: `advanced.${services.users}.get`
    },
    accept: {
      type: Array,
      default: () => {
        return permissionPresets.resellerUp
      }
    },

    itemsDisabled: {
      type: Array,
      default: () => {
        return []
      }
    },

    label: String,
    hint: String,

    query: {
      type: Object,
      default: () => {
        return { isActive: true }
      }
    },

    labelMode: {
      type: String,
      default: labelModes.line,
      validator: value => {
        return Object.values(labelModes).includes(value)
      }
    },

    flat: {
      type: Boolean,
      default: true
    },
    dense: {
      type: Boolean,
      default: false
    },
    details: {
      type: Boolean,
      default: false
    },
    autocomplete: {
      type: Boolean,
      default: true
    },
    required: {
      type: Boolean,
      default: false
    },
    setRequiredOnMounted: {
      type: Boolean,
      default: true
    },
    rounded: {
      type: Boolean,
      default: true
    },
    multiple: {
      type: Boolean,
      default: false
    },

    clearItems: {
      type: Function,
      default: v => {
        return v
      }
    },

    loading: Boolean,
    disabled: Boolean
  },

  computed: {
    computedQuery() {
      const result = cloneDeep(this.query)
      for (const key in result) {
        if (result[key] === undefined || result[key] === null) {
          delete result[key]
        }
      }

      return result
    }
  },

  render
}
